'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldHideWelcomeMessage = undefined;

var _reselect = require('reselect');

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _getWidgetUiState = require('./getWidgetUiState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getShouldHideWelcomeMessage = exports.getShouldHideWelcomeMessage = (0, _reselect.createSelector)([_getWidgetUiState.getWidgetUiState], (0, _getIn2.default)(['hideWelcomeMessage']));